import { Dialog } from "@merge-api/merge-javascript-shared";
import React, { useEffect, useState } from "react";
import { Prompt, useHistory, useParams } from "react-router-dom";
import { APICategory } from "../../../../models/Entities";
import { Location } from "history";

type ConditionPresetConfirmDiscardChangesDialogProps = {
  hasChanges: boolean;
};

const ConditionPresetConfirmDiscardChangesDialog = ({
  hasChanges = true,
}: ConditionPresetConfirmDiscardChangesDialogProps) => {
  // state
  const [nextLocation, setNextLocation] = useState<Location>();
  const [previousCategory, setPreviousCategory] = useState<APICategory>();

  // hooks
  const history = useHistory();
  const { category } = useParams<{ category: APICategory }>();

  // effects
  // update previousCategory
  useEffect(() => {
    if (category !== previousCategory) {
      setPreviousCategory;
    }
  }, [category, previousCategory]);

  // event handlers
  const onNavigateAway = (nextLocation: Location) => {
    if (hasChanges) {
      setNextLocation(nextLocation);
      return false;
    } else {
      return true;
    }
  };

  const onDiscardChangesClick = () => {
    if (nextLocation) {
      history.push(nextLocation.pathname);
      setNextLocation(undefined);
    }
  };

  const onContinueEditingClick = () => {
    setNextLocation(undefined);
    history.push(`/configuration/selective-sync/${category!}`);
  };

  return (
    <>
      <Prompt when={!nextLocation} message={onNavigateAway} />
      <Dialog
        variant="sm"
        title="Confirm discard changes"
        open={!!nextLocation}
        onClose={onContinueEditingClick}
        primaryButtonText="Yes, discard changes"
        onPrimaryButtonClick={onDiscardChangesClick}
        secondaryButtonText="Continue editing"
      >
        You have unpublished changes. Are you sure you want to discard changes?
      </Dialog>
    </>
  );
};

export default ConditionPresetConfirmDiscardChangesDialog;
